import { useState } from 'react';
import { NJButton, NJHeading, NJText } from '@engie-group/fluid-design-system-react';
import { UMSelect } from '../../urbanmap/_components';
import { DECISIONS } from './decisions';
import type { Destination } from './types';

export type DecisionId = typeof DECISIONS[number]['id'];
export function DecisionNote({ id, onOpen }: { id: string; onOpen: (id: string) => void }) {
  const d = DECISIONS.find(item => item.id === id)!;
  return <div className="pu-decision" data-decision-id={id}>
    <NJButton label="À arbitrer" aria-label={`À arbitrer · ${d.title}`} icon="help_outline" scale="sm" emphasis="minimal" onClick={() => onOpen(id)} />
    <NJText as="div" scale="sm"><strong>{d.title}</strong></NJText>
    <NJText as="div" scale="sm">{d.question}</NJText>
  </div>;
}
export function DecisionPanel({ selected, visit, close }: {
  selected: string | null; visit: (destination: Destination, id?: string) => void; close: () => void;
}) {
  const [variants, setVariants] = useState<Record<string, string>>({});
  const ordered = selected ? [...DECISIONS].sort((a, b) => Number(b.id === selected) - Number(a.id === selected)) : DECISIONS;
  return <section className="pu-review sp-stack" aria-label="Décisions ouvertes">
    <div className="sp-row sp-between">
      <NJHeading as="h2" scale="md">Décisions ouvertes</NJHeading>
      <NJButton label="Fermer les décisions" icon="close" emphasis="minimal" onClick={close} />
    </div>
    <NJText>Ces variantes servent à la discussion. Les sélectionner ne valide aucune règle et ne modifie pas les données du projet.</NJText>
    <div className="pu-decision-grid">{ordered.map(d => <article className="pu-card sp-stack" key={d.id}>
      <NJText as="div" className="pu-label">À arbitrer · {d.id}</NJText>
      <NJHeading as="h3" scale="sm">{d.title}</NJHeading>
      <NJText>{d.question}</NJText><NJText scale="sm">{d.impact}</NJText>
      <UMSelect ariaLabel={`Variante exploratoire · ${d.title}`} value={variants[d.id] ?? ''}
        options={[{ value: '', label: 'Aucune préférence exprimée' }, ...d.variants.map(v => ({ value: v, label: v }))]}
        onChange={v => setVariants(s => ({ ...s, [d.id]: v }))} />
      {variants[d.id] && <NJText role="status" scale="sm">Préférence exploratoire : {variants[d.id]}. Sans effet métier, non validée, non sauvegardée.</NJText>}
      <NJButton label={`Voir l’endroit concerné · ${d.title}`} icon="arrow_forward" emphasis="subtle" scale="sm"
        onClick={() => visit(d.destination, d.id)} />
    </article>)}</div>
  </section>;
}
